function defaultClearSession() {
  if (typeof localStorage === 'undefined') return;
  localStorage.removeItem('token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
}

export function buildSessionExpiredState(location = {}) {
  const pathname = location.pathname ?? '';
  const search = location.search ?? '';
  const hash = location.hash ?? '';

  return {
    from: `${pathname}${search}${hash}`,
    reason: 'session_expired',
  };
}

export function redirectToSessionExpiredLogin({
  navigate,
  location,
  onBeforeNavigate,
  clearSession = defaultClearSession,
}) {
  clearSession();
  onBeforeNavigate?.();
  navigate('/login', {
    replace: true,
    state: buildSessionExpiredState(location),
  });
}
